import { render, staticRenderFns } from "./OptedCard.vue?vue&type=template&id=45e1c3d2&scoped=true"
import script from "./OptedCard.vue?vue&type=script&lang=js"
export * from "./OptedCard.vue?vue&type=script&lang=js"
import style0 from "./OptedCard.vue?vue&type=style&index=0&id=45e1c3d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e1c3d2",
  null
  
)

export default component.exports